import React from 'react';

const CommunityEngagement = () => {
  return (
    <section className="py-16 px-4 md:px-8 lg:px-16 bg-gradient-to-br from-dark-2 to-blue-2 text-white">
      <div className="max-w-7xl mx-auto">
        {/* Section principale */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 font-sans">
            Toujours plus vivant grâce à toi
          </h2>
          <p className="text-xl md:text-2xl text-light-3 mb-10 max-w-3xl mx-auto font-sans leading-relaxed">
            "Ici, chaque voix compte. Plus tu participes, plus la communauté devient riche et inspirante."
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Action 1 */}
            <div className="bg-dark-5 bg-opacity-50 rounded-2xl p-6 hover:bg-opacity-70 transition-all duration-300">
              <div className="text-3xl mb-4">👉</div>
              <h3 className="text-lg font-semibold mb-3 font-sans">Créer un compte et rejoindre le forum</h3>
              <p className="text-light-3 font-sans text-normal">
                Inscris-toi en 2 minutes et découvre un univers d'échanges et de partages.
              </p>
              <button className="mt-4 bg-purple-1 hover:bg-purple-800 text-white font-sans font-medium py-2 px-4 rounded-lg transition-colors duration-300 w-full">
                S'inscrire
              </button>
            </div>
            
            {/* Action 2 */}
            <div className="bg-dark-5 bg-opacity-50 rounded-2xl p-6 hover:bg-opacity-70 transition-all duration-300">
              <div className="text-3xl mb-4">👥</div>
              <h3 className="text-lg font-semibold mb-3 font-sans">Participer à une discussion active</h3>
              <p className="text-light-3 font-sans text-normal">
                Rejoins les conversations en cours et apporte ta pierre à l'édifice.
              </p>
              <button className="mt-4 bg-blue-1 hover:bg-blue-800 text-white font-sans font-medium py-2 px-4 rounded-lg transition-colors duration-300 w-full">
                Voir les discussions
              </button>
            </div>
            
            {/* Action 3 */}
            <div className="bg-dark-5 bg-opacity-50 rounded-2xl p-6 hover:bg-opacity-70 transition-all duration-300">
              <div className="text-3xl mb-4">🏅</div>
              <h3 className="text-lg font-semibold mb-3 font-sans">Gagner des badges de contribution</h3>
              <p className="text-light-3 font-sans text-normal">
                Sois reconnu pour ton aide aux autres et le partage de tes projets.
              </p>
              <button className="mt-4 bg-green-1 hover:bg-green-600 text-dark-2 font-sans font-medium py-2 px-4 rounded-lg transition-colors duration-300 w-full">
                Découvrir les badges
              </button>
            </div>
          </div>
        </div>
        
        {/* Charte de la communauté */}
        <div className="bg-dark-4 bg-opacity-70 rounded-2xl p-8">
          <h3 className="text-xl font-bold mb-6 text-center font-sans">Charte de la communauté NextMaker</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Règle 1 */}
            <div className="text-center">
              <div className="text-3xl mb-4">🤝</div>
              <h4 className="text-lg font-semibold mb-2 font-sans text-green-1">Bienveillance et entraide avant tout</h4>
              <p className="text-light-3 font-sans text-normal">
                Nous encourageons un environnement où chacun se sent en sécurité pour poser des questions et partager ses connaissances.
              </p>
            </div>
            
            {/* Règle 2 */}
            <div className="text-center">
              <div className="text-3xl mb-4">💡</div>
              <h4 className="text-lg font-semibold mb-2 font-sans text-purple-1">Partage d'expériences et de projets concrets</h4>
              <p className="text-light-3 font-sans text-normal">
                Valorisons les retours d'expérience, les tutoriels et les démonstrations qui aident toute la communauté à progresser.
              </p>
            </div>
            
            {/* Règle 3 */}
            <div className="text-center">
              <div className="text-3xl mb-4">🌍</div>
              <h4 className="text-lg font-semibold mb-2 font-sans text-blue-1">Respect de chacun, ouverture à toutes les idées</h4>
              <p className="text-light-3 font-sans text-normal">
                Nous célébrons la diversité des perspectives et encourageons le dialogue respectueux entre tous les membres.
              </p>
            </div>
          </div>
          
          <div className="text-center mt-8">
            <button className="border border-light-3 text-light-3 hover:bg-white hover:text-dark-2 font-sans font-medium py-2 px-6 rounded-lg transition-all duration-300">
              Lire la charte complète
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityEngagement;